/* eslint-disable no-unused-vars */

import React, { useState, useEffect, useMemo } from "react";
import { Link, useParams, useHistory } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  FormGroup,
  Card,
  CardBody,
  Spinner,
  InputGroup,
  Button,
  Label,
  InputGroupAddon,
} from "reactstrap";
import Select from "react-select";
import SwitchEvent from "../../components/Skills/ChatEvent/SwitchEvent";

import "./User.scss";
// Toast
import toastr from "toastr";
import "toastr/build/toastr.min.css";

// availity-reactstrap-validation
import {
  AvForm,
  AvField,
  AvGroup,
  AvFeedback,
  AvInput,
} from "availity-reactstrap-validation";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

// //Import customDatePicker
// import CustomDatePicker2 from "../../components/Common/CustomDatePicker2";

//i18n
import { withTranslation } from "react-i18next";

//Redux
import { useDispatch, useSelector } from "react-redux";

//Lodash
import { isEqual } from "lodash";

//Import Custom ExtraFields Component
import ExtraFields from "./ExtraFields";

import {
  getUser,
  createUser,
  editUser,
  resetUser,
  resetUsers,
  resetError,
  editPassword,
} from "../../store/users/actions";

const NewUser = ({ t }) => {
  let { idUser } = useParams();
  const dispatch = useDispatch();
  const history = useHistory();

  const {
    dataUserGetSet,
    dataUserEditCreate,
    loadingUser,
    loadingUserPassword,
    loadingUserEditCreate,
    successUser,
    errorUser,
  } = useSelector((state) => state.User);

  const { data } = useSelector((state) => state.Login);

  const minMaxChat = 0;
  const maxMaxChat = 20;
  const activeDefault = true;

  const [userValues, setUserValues] = useState({
    name: "",
    email: "",
    active: activeDefault,
    nickname: "",
    url_avatar: null,
    max_chats: null,
    profiles: "",
    profilesBk: "",
    skills: [],
    skillsBk: [],
    groups: [],
    groupsBk: [],
    departments: [],
    departmentsBk: [],
    extra: [],
    extraBk: [],
    externalAccess: false,
    external_id: "",
    isAutomationOnly: false,
  });

  const [isAutomationOnly, setIsAutomationOnly] = useState(
    userValues.isAutomationOnly
  );
  const [userExternalAccess, setUserExternalAccess] = useState(
    userValues.externalAccess
  );
  const [newFields, setNewFields] = useState({});
  const [enableSubmit, setEnableSubmit] = useState(false);
  const [departmentId, setDepartmentId] = useState();
  const [optProfile, setOptProfile] = useState({ options: [] });
  const [optSkill, setOptSkill] = useState({ options: [] });
  const [optGroup, setOptGroup] = useState({ options: [] });
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");
  const [isVisiblePassword, setIsVisiblePassword] = useState(false);
  const [isVisibleConfirmPassword, setIsVisibleConfirmPassword] =
    useState(false);

  const isAgent = useMemo(() => {
    let objDepartment = dataUserGetSet?.data?.form?.departments?.find(
      (department) => department.id === departmentId
    );

    return objDepartment?.profiles?.find(
      (profile) => profile?.id === userValues?.profiles
    )?.isAgent;
  }, [dataUserGetSet, userValues?.profiles, departmentId]);

  const handleCreateEditUser = () => {
    if (idUser) {
      dispatch(editUser(idUser, newFields));
    } else {
      dispatch(createUser(newFields));
    }
  };

  function getRandomInt(min, max) {
    var byteArray = new Uint8Array(1);
    window.crypto.getRandomValues(byteArray);

    var range = max - min + 1;
    var max_range = 256;
    if (byteArray[0] >= Math.floor(max_range / range) * range)
      return getRandomInt(min, max);
    return min + (byteArray[0] % range);
  }
  function getRandomSpecialCharacter() {
    const specialChars = "!@#$%^&*()_+-=[]{};':\"\\|,.<>/?";
    return specialChars.charAt(Math.floor(Math.random() * specialChars.length));
  }
  const handleGeneratePassword = () => {
    var array = new Uint32Array(12);
    let cryptoValue = window.crypto.getRandomValues(array);

    let randomicInt = getRandomInt(1, 25);
    const randomPass = cryptoValue[0].toString(36);
    const randomCapitalLetter = String.fromCharCode(65 + randomicInt);
    const randomSpecialChar = getRandomSpecialCharacter();
    const randomNumber = Math.floor(Math.random() * 10);
    let saltValue = randomPass.substr(1, 4);

    const randomPassword =
      randomCapitalLetter.toLowerCase() +
      randomPass +
      randomCapitalLetter +
      randomSpecialChar +
      randomNumber +
      saltValue;

    setNewPassword(randomPassword);
    setConfirmNewPassword(randomPassword);

    setNewFields((previous) => ({
      ...previous,
      password: randomPassword,
    }));
  };

  const handleChangePassword = (e) => {
    e.preventDefault();

    if (newPassword === confirmNewPassword) {
      if (
        newPassword.match(
          /^(?=.*[A-Z])(?=.*[0-9])(?=.*[~`!@#$%^&*()--+={}[\]|\\:;"'<>,.?/_]).{8,}$/
        )
      ) {
        if (idUser) {
          dispatch(editPassword(idUser, newPassword));
        }
      } else {
        showToast(
          "error",
          t(
            "Password must be at least 8 characters long, contain at least one uppercase character, contain at least one number and contain at least one special character"
          )
        );
      }
    } else {
      showToast("error", t("Passwords do not match"));
    }
  };

  const showToast = (type, message) => {
    toastr[type](message);
  };
  toastr.options = {
    closeButton: false,
    debug: false,
    newestOnTop: false,
    progressBar: true,
    positionClass: "toast-top-right",
    preventDuplicates: true,
    onclick: null,
    showDuration: "200",
    hideDuration: "200",
    timeOut: "2000",
    extendedTimeOut: "2000",
    showEasing: "swing",
    hideEasing: "linear",
    showMethod: "fadeIn",
    hideMethod: "fadeOut",
    onHidden: () =>
      successUser &&
      dispatch(resetUser()) &&
      dispatch(resetUsers()) &&
      history.push("/users"),
  };

  const checkSubmit = () => {
    if (Object.keys(newFields).length !== 0) setEnableSubmit(true);
    else setEnableSubmit(false);
  };

  useEffect(() => {
    checkSubmit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [newFields]);

  useEffect(() => {
    setIsAutomationOnly(userValues.isAutomationOnly);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userValues.isAutomationOnly]);

  useEffect(() => {
    setUserExternalAccess(userValues.externalAccess);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userValues.externalAccess]);

  useEffect(() => {
    dispatch(resetUser());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (idUser) {
      dispatch(getUser(idUser, true));
    } else {
      dispatch(getUser(null, true));
      setNewFields((previous) => ({
        ...previous,
        active: activeDefault,
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idUser]);

  useEffect(() => {
    if (
      idUser &&
      dataUserGetSet &&
      dataUserGetSet.data &&
      dataUserGetSet.data.user
    ) {
      setDepartmentId(dataUserGetSet.data.user.department_id);
      let departmentsToPrint = [];
      let profilesToPrint = [];
      let skillsToPrint = [];
      let groupsToPrint = [];
      if (dataUserGetSet.data.user.profiles) {
        profilesToPrint = dataUserGetSet.data.user.profiles.map(
          (profile, key) => ({
            key: key,
            value: profile.id,
            label: profile.name,
          })
        );
      }
      if (dataUserGetSet.data.user.skills) {
        skillsToPrint = dataUserGetSet.data.user.skills.map((skill, key) => ({
          key: key,
          value: skill.id,
          label: skill.name,
        }));
      }
      if (dataUserGetSet.data.user.groups) {
        groupsToPrint = dataUserGetSet.data.user.groups.map((group, key) => ({
          key: key,
          value: group.id,
          label: group.name,
        }));
      }
      if (dataUserGetSet.data.user.departments) {
        departmentsToPrint = dataUserGetSet.data.user.departments.map(
          (department, key) => ({
            key: key,
            value: department.id,
            label: department.name,
          })
        );
      }

      setUserValues((previous) => ({
        ...previous,
        name: dataUserGetSet.data.user.name,
        email: dataUserGetSet.data.user.email,
        nickname: dataUserGetSet.data.user.nickname,
        max_chats: dataUserGetSet.data.user.max_chats,
        departments: departmentsToPrint[0].value,
        profiles: profilesToPrint[0].value,
        skills: skillsToPrint,
        groups: groupsToPrint,
        departmentsBk: departmentsToPrint.map((item) => item.value),
        profilesBk: profilesToPrint.map((item) => item.value),
        skillsBk: skillsToPrint.map((item) => item.value),
        groupsBk: groupsToPrint.map((item) => item.value),
        extraBk: dataUserGetSet.data.user.extra,
        externalAccess: dataUserGetSet.data.user.external_access,
        externalId: dataUserGetSet.data.user.external_id,
        isAutomationOnly: dataUserGetSet.data.user.is_automation_only,
      }));
    } else if (
      Array.isArray(dataUserGetSet?.data?.form?.departments) &&
      dataUserGetSet.data.form.departments.length >= 1
    ) {
      setDepartmentId(dataUserGetSet.data.form.departments[0].id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataUserGetSet]);

  useEffect(() => {
    if (dataUserEditCreate && dataUserEditCreate.message) {
      showToast("success", t(dataUserEditCreate.message));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [successUser]);

  useEffect(() => {
    if (errorUser && typeof errorUser === "object") {
      errorUser.map((error) => showToast("error", t(error.value)));
      dispatch(resetError());
    } else {
      if (errorUser) {
        showToast("error", t(errorUser));
        dispatch(resetError());
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errorUser]);

  const optionsDepartment = () => {
    let options = [];

    if (loadingUser) {
      options.push({
        value: "empty",
        label: `${t("Loading")} ...`,
        isDisabled: true,
      });
    } else {
      if (
        dataUserGetSet &&
        dataUserGetSet.data &&
        dataUserGetSet.data.form &&
        dataUserGetSet.data.form.departments &&
        dataUserGetSet.data.form.departments.length > 0
      ) {
        options.push({
          value: "",
          label: t("Select"),
          isDisabled: true,
        });
        dataUserGetSet.data.form.departments.map((department, key) =>
          options.push({
            key: key,
            value: department.id,
            label: department.name,
          })
        );
      } else {
        options.push({
          value: "empty",
          label: t("No matching records found"),
          isDisabled: true,
        });
      }
    }

    return options;
  };

  const optionsProfileNoDepartment = () => {
    let options = [];

    if (loadingUser) {
      options.push({
        value: "",
        label: t("Loading..."),
        isDisabled: true,
      });
    } else {
      if (dataUserGetSet?.data?.form?.departments[0]?.profiles?.length > 0) {
        options.push({
          value: "",
          label: t("Select"),
          isDisabled: true,
        });
        dataUserGetSet.data.form.departments[0].profiles.map((profile, key) =>
          options.push({
            key: key,
            value: profile.id,
            label: profile.name,
          })
        );
      } else {
        options.push({
          value: "empty",
          label: t("No matching records found"),
          isDisabled: true,
        });
      }
    }

    return options;
  };

  const optionsProfile = (objDepartment) => {
    let options = [];
    if (loadingUser) {
      options.push({
        value: "empty",
        label: `${t("Loading")} ...`,
        isDisabled: true,
      });
    } else {
      options.push({
        value: "",
        label: t("Select"),
        isDisabled: true,
      });
      if (
        objDepartment &&
        objDepartment.profiles &&
        objDepartment.profiles.length > 0
      ) {
        objDepartment.profiles.map((profile, key) =>
          options.push({
            key: key,
            value: profile.id,
            label: profile.name,
            isAgent: profile?.isAgent ?? false,
          })
        );
      } else {
        if (objDepartment && options.length > 0) options.pop();
        options.push({
          value: "empty",
          label: t("No matching records found"),
          isDisabled: true,
        });
      }
    }
    setOptProfile({ options: options });
  };

  const optionsSkillNoDepartment = () => {
    let options = [];

    if (loadingUser) {
      options.push({
        value: "",
        label: t("Loading..."),
        isDisabled: true,
      });
    } else {
      if (dataUserGetSet?.data?.form?.departments[0]?.skills?.length > 0) {
        options.push({
          value: "",
          label: t("Select"),
          isDisabled: true,
        });
        dataUserGetSet.data.form.departments[0].skills.map((skill, key) =>
          options.push({
            key: key,
            value: skill.id,
            label: skill.name,
          })
        );
      } else {
        options.push({
          value: "empty",
          label: t("No matching records found"),
          isDisabled: true,
        });
      }
    }
    return options;
  };

  const optionsSkill = (objDepartment) => {
    let options = [];

    if (loadingUser) {
      options.push({
        value: "empty",
        label: `${t("Loading")} ...`,
        isDisabled: true,
      });
    } else {
      if (
        objDepartment &&
        objDepartment.skills &&
        objDepartment.skills.length > 0
      ) {
        objDepartment.skills.map((skill, key) =>
          options.push({
            key: key,
            value: skill.id,
            label: skill.name,
          })
        );
      } else {
        options.push({
          value: "empty",
          label: t("No matching records found"),
          isDisabled: true,
        });
      }
    }
    setOptSkill({ options: options });
  };

  const optionsGroupNoDepartment = () => {
    let options = [];

    if (loadingUser) {
      options.push({
        value: "",
        label: t("Loading..."),
        isDisabled: true,
      });
    } else {
      if (dataUserGetSet?.data?.form?.departments[0]?.groups?.length > 0) {
        options.push({
          value: "",
          label: t("Select"),
          isDisabled: true,
        });
        dataUserGetSet.data.form.departments[0].groups.map((group, key) =>
          options.push({
            key: key,
            value: group.id,
            label: group.name,
          })
        );
      } else {
        options.push({
          value: "empty",
          label: t("No matching records found"),
          isDisabled: true,
        });
      }
    }
    return options;
  };

  const optionsGroup = (objDepartment) => {
    let options = [];
    if (loadingUser) {
      options.push({
        value: "empty",
        label: `${t("Loading")} ...`,
        isDisabled: true,
      });
    } else {
      if (
        objDepartment &&
        objDepartment.groups &&
        objDepartment.groups.length > 0
      ) {
        objDepartment.groups.map((group, key) =>
          options.push({
            key: key,
            value: group.id,
            label: group.name,
          })
        );
      } else {
        options.push({
          value: "empty",
          label: t("No matching records found"),
          isDisabled: true,
        });
      }
    }
    setOptGroup({ options: options });

    return options;
  };

  useEffect(() => {
    let objDepartment = dataUserGetSet?.data?.form?.departments?.find(
      (department) => department.id === departmentId
    );
    optionsProfile(objDepartment);
    optionsSkill(objDepartment);
    optionsGroup(objDepartment);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [departmentId]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs
            mainPath="/users"
            path={idUser ? "/user/" + idUser : "/user"}
            title={t("Users")}
            breadcrumbItem={!idUser ? t("Create user") : t("Edit User")}
          />
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <AvForm
                    onValidSubmit={handleCreateEditUser}
                    validateOnChange={false}
                    validateOnSubmit={true}
                  >
                    <Row>
                      <Col sm="6">
                        <FormGroup>
                          <AvField
                            label={t("Name") + " *"}
                            id="name"
                            name="name"
                            type="text"
                            className="form-control"
                            placeholder={t("User name")}
                            onChange={(e) => {
                              if (e.target.value === userValues.name) {
                                delete newFields.name;
                                checkSubmit();
                              } else {
                                setNewFields((previous) => ({
                                  ...previous,
                                  name: e.target.value,
                                }));
                              }
                            }}
                            value={userValues.name}
                            validate={{
                              required: {
                                value: true,
                                errorMessage: t("Required Field"),
                              },
                              maxLength: {
                                value: 255,
                                errorMessage: t("Invalid field"),
                              },
                              pattern: {
                                value: /^[A-Za-z áàâãéèêíïóôõöúç]*$/i, // only letters and space
                                errorMessage: t(
                                  "Your name must be composed only with letter and space"
                                ),
                              },
                            }}
                          />
                        </FormGroup>
                        <FormGroup>
                          <AvField
                            label={t("Email") + " *"}
                            id="registration-email"
                            name="registrationemail"
                            type="email"
                            className="form-control"
                            placeholder={t("example@example.com")}
                            onChange={(e) => {
                              if (e.target.value === userValues.email) {
                                delete newFields.email;
                                checkSubmit();
                              } else {
                                setNewFields((previous) => ({
                                  ...previous,
                                  email: e.target.value,
                                }));
                              }
                            }}
                            value={userValues.email}
                            validate={{
                              email: {
                                value: true,
                                errorMessage: t("Incorrect email"),
                              },
                              maxLength: {
                                value: 100,
                                errorMessage: t("Invalid field"),
                              },
                              required: {
                                value: true,
                                errorMessage: t("Required Field"),
                              },
                            }}
                          />
                        </FormGroup>
                        <FormGroup className="select2-container">
                          <AvField
                            id="max-chats"
                            name="max-chats"
                            className="form-control"
                            type="number"
                            label={t("Max Chat") + " *"}
                            placeholder={t("Enter maximum chats")}
                            onChange={(e) => {
                              if (e.target.value === userValues.max_chats) {
                                delete newFields.max_chats;
                                checkSubmit();
                              } else {
                                setNewFields((previous) => ({
                                  ...previous,
                                  max_chats: e.target.value,
                                }));
                              }
                            }}
                            value={userValues.max_chats}
                            validate={{
                              required: {
                                value: true,
                                errorMessage: t("Required Field"),
                              },
                              min: {
                                value: minMaxChat,
                                errorMessage: `${t("Minimum")} ${minMaxChat}`,
                              },
                              max: {
                                value: maxMaxChat,
                                errorMessage: `${t("Maximum")} ${maxMaxChat}`,
                              },
                            }}
                          />
                        </FormGroup>
                        <FormGroup>
                          <AvField
                            label={t("Nickname") + " *"}
                            id="nickname"
                            name="nickname"
                            type="text"
                            className="form-control"
                            placeholder={t("User nickname")}
                            onChange={(e) => {
                              if (e.target.value === userValues.nickname) {
                                delete newFields.nickname;
                                checkSubmit();
                              } else {
                                setNewFields((previous) => ({
                                  ...previous,
                                  nickname: e.target.value,
                                }));
                              }
                            }}
                            value={userValues.nickname}
                            validate={{
                              required: {
                                value: true,
                                errorMessage: t("Required Field"),
                              },
                              minLength: {
                                value: 3,
                                errorMessage: t("Invalid field"),
                              },
                              maxLength: {
                                value: 254,
                                errorMessage: t("Invalid field"),
                              },
                            }}
                          />

                          {dataUserGetSet?.data?.form?.externalIdRequired !==
                            undefined && (
                            <AvField
                              label={
                                t("external identifier") +
                                (dataUserGetSet?.data?.form?.externalIdRequired
                                  ? " *"
                                  : "")
                              }
                              name="externalId"
                              type="text"
                              className="form-control"
                              placeholder={t("external user identifier")}
                              onChange={(e) => {
                                if (e.target.value === userValues.externalId) {
                                  delete newFields.external_id;
                                  checkSubmit();
                                } else {
                                  setNewFields((previous) => ({
                                    ...previous,
                                    external_id: e.target.value,
                                  }));
                                }
                              }}
                              value={userValues.externalId}
                              validate={{
                                maxLength: {
                                  value: 150,
                                  errorMessage: t("Invalid field"),
                                },
                                required: {
                                  value:
                                    dataUserGetSet?.data?.form
                                      ?.externalIdRequired,
                                  errorMessage: t("Required Field"),
                                },
                              }}
                            />
                          )}
                        </FormGroup>

                        {dataUserGetSet?.data?.form?.extra?.length > 0 && (
                          <FormGroup className="form-box">
                            <Label>{t("Extra")}</Label>
                            <ExtraFields
                              fields={dataUserGetSet?.data?.form?.extra}
                              onChange={(e) => {
                                if (isEqual(e, userValues.extra)) {
                                  delete newFields.extra;
                                  checkSubmit();
                                } else {
                                  setNewFields((previous) => ({
                                    ...previous,
                                    extra: e,
                                  }));
                                }
                              }}
                              value={userValues.extraBk}
                            />
                          </FormGroup>
                        )}
                        {/* toglee sso active */}
                        <FormGroup className="form-box">
                          <SwitchEvent
                            id="externalAccessComponent"
                            title="Limit external access"
                            tooltip="This button enables the functionality to limit external access at user login"
                            value={userExternalAccess}
                            onChange={(val) => {
                              setUserExternalAccess(val);
                              if (val === userValues.externalAccess) {
                                delete newFields.external_access;
                                checkSubmit();
                              } else {
                                setNewFields((previous) => ({
                                  ...previous,
                                  external_access: val,
                                }));
                              }
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col sm="6">
                        <FormGroup className="select2-container">
                          <AvField
                            name="profile"
                            className="form-control"
                            type="select"
                            label={t("Profile") + " *"}
                            onChange={(e) => {
                              let profileId = e.target.value;
                              if (profileId === userValues.profilesBk[0]) {
                                delete newFields.profile_id;
                                checkSubmit();
                              } else {
                                setNewFields((previous) => ({
                                  ...previous,
                                  profile_id: profileId,
                                  group_id: [],
                                }));
                              }
                              setUserValues({
                                ...userValues,
                                groups: null,
                                profiles: profileId,
                              });
                            }}
                            value={userValues.profiles ?? ""}
                            validate={{
                              required: {
                                value: true,
                                errorMessage: t("Required Field"),
                              },
                            }}
                            //Uncomment if profiles, skills, groups are by department
                            //disabled={!departmentId ? true : false}
                          >
                            {optionsProfileNoDepartment().map(
                              (profile, key) => (
                                <option
                                  key={key}
                                  value={profile.value}
                                  disabled={profile.isDisabled}
                                >
                                  {profile.label}
                                </option>
                              )
                            )}
                          </AvField>
                        </FormGroup>
                        <FormGroup className="select2-container">
                          <Label className="control-label">{t("Skills")}</Label>
                          <Select
                            classNamePrefix="select2-selection"
                            placeholder={t("Select") + "..."}
                            title={t("Skills")}
                            //Change to optSkill.options if profiles, skills, groups are by department
                            options={optionsSkillNoDepartment()}
                            onChange={(e) => {
                              if (
                                e &&
                                JSON.stringify(e.map((item) => item.value)) ===
                                  JSON.stringify(userValues.skillsBk)
                              ) {
                                delete newFields.skill_id;
                                checkSubmit();
                              } else {
                                setNewFields({
                                  ...newFields,
                                  skill_id: e
                                    ? e.map((item) => item.value)
                                    : [],
                                });
                              }
                              setUserValues({
                                ...userValues,
                                skills: e ? e : [],
                              });
                            }}
                            value={userValues.skills}
                            isDisabled={!departmentId ? true : false}
                            isMulti
                          />
                        </FormGroup>
                        <FormGroup className="select2-container">
                          <Label className="control-label">{t("Group")}</Label>
                          <Select
                            classNamePrefix="select2-selection"
                            placeholder={t("Select") + "..."}
                            title={t("Group")}
                            //Change to optGroup.options if profiles, skills, groups are by department
                            options={optionsGroupNoDepartment()}
                            onChange={(e) => {
                              if (isAgent) {
                                if (
                                  e &&
                                  e.value ===
                                    JSON.stringify(userValues.groupsBk)
                                ) {
                                  delete newFields.group_id;
                                  checkSubmit();
                                } else {
                                  setNewFields({
                                    ...newFields,
                                    group_id: e ? [e.value] : [],
                                  });
                                }

                                setUserValues({
                                  ...userValues,
                                  groups: e ? e : [],
                                });
                              } else {
                                if (
                                  e &&
                                  JSON.stringify(
                                    e.map((item) => item.value)
                                  ) === JSON.stringify(userValues.groupsBk)
                                ) {
                                  delete newFields.group_id;
                                  checkSubmit();
                                } else {
                                  setNewFields({
                                    ...newFields,
                                    group_id: e
                                      ? e.map((item) => item.value)
                                      : [],
                                  });
                                }
                                setUserValues({
                                  ...userValues,
                                  groups: e ? e : [],
                                });
                              }
                            }}
                            value={userValues.groups}
                            isDisabled={!departmentId ? true : false}
                            isMulti={!isAgent}
                          />
                        </FormGroup>
                        {!idUser && data.permissions["change_password"] && (
                          <>
                            <AvGroup>
                              <Label for="password">{t("New password")}</Label>
                              <InputGroup>
                                <AvInput
                                  name="password"
                                  type={isVisiblePassword ? "text" : "password"}
                                  value={newPassword}
                                  onChange={(e) => {
                                    if (e.target.value === confirmNewPassword) {
                                      setNewFields((previous) => ({
                                        ...previous,
                                        password: e.target.value,
                                      }));
                                    } else {
                                      delete newFields.password;
                                      checkSubmit();
                                    }
                                    setNewPassword(e.target.value);
                                  }}
                                  placeholder={t("New password")}
                                  validate={{
                                    pattern: {
                                      value:
                                        /^(?=.*[A-Z])(?=.*[0-9])(?=.*[~`!@#$%^&*()--+={}[\]|\\:;"'<>,.?/_]).{8,}$/,
                                      errorMessage: t(
                                        "Password must be at least 8 characters long, contain at least one uppercase character, contain at least one number and contain at least one special character"
                                      ),
                                    },
                                  }}
                                />
                                <InputGroupAddon addonType="append">
                                  <button
                                    type="button"
                                    style={{
                                      backgroundColor: "#2e3548",
                                      color: "#bfc8e2",
                                      outline: "none",
                                      border: "1px solid #32394e",
                                      borderRadius: "0 0.25em 0.25em 0",
                                      width: "3em",
                                      marginLeft: "1px",
                                    }}
                                    onClick={() =>
                                      setIsVisiblePassword(!isVisiblePassword)
                                    }
                                  >
                                    {isVisiblePassword ? (
                                      <i className="bx bx-hide"></i>
                                    ) : (
                                      <i className="bx bx-show"></i>
                                    )}
                                  </button>
                                </InputGroupAddon>
                                <AvFeedback>
                                  {t(
                                    "Password must be at least 8 characters long, contain at least one uppercase character, contain at least one number and contain at least one special character"
                                  )}
                                </AvFeedback>
                              </InputGroup>
                            </AvGroup>

                            <AvGroup>
                              <Label for="passwordConfirm">
                                {t("Confirm new password")}
                              </Label>
                              <InputGroup>
                                <AvInput
                                  name="passwordConfirm"
                                  type={
                                    isVisibleConfirmPassword
                                      ? "text"
                                      : "password"
                                  }
                                  value={confirmNewPassword}
                                  onChange={(e) => {
                                    if (e.target.value === newPassword) {
                                      setNewFields((previous) => ({
                                        ...previous,
                                        password: e.target.value,
                                      }));
                                    } else {
                                      delete newFields.password;
                                      checkSubmit();
                                    }
                                    setConfirmNewPassword(e.target.value);
                                  }}
                                  placeholder={t("Confirm new password")}
                                  validate={{
                                    pattern: {
                                      value:
                                        /^(?=.*[A-Z])(?=.*[0-9])(?=.*[~`!@#$%^&*()--+={}[\]|\\:;"'<>,.?/_]).{8,}$/,
                                      errorMessage: t(
                                        "Password must be at least 8 characters long, contain at least one uppercase character, contain at least one number and contain at least one special character"
                                      ),
                                    },
                                    match: {
                                      value: "password",
                                      errorMessage: t(
                                        "Passwords do not match, try again."
                                      ),
                                    },
                                  }}
                                />
                                <InputGroupAddon addonType="append">
                                  <button
                                    type="button"
                                    style={{
                                      backgroundColor: "#2e3548",
                                      color: "#bfc8e2",
                                      outline: "none",
                                      border: "1px solid #32394e",
                                      borderRadius: "0 0.25em 0.25em 0",
                                      width: "3em",
                                      marginLeft: "1px",
                                    }}
                                    onClick={() =>
                                      setIsVisibleConfirmPassword(
                                        !isVisibleConfirmPassword
                                      )
                                    }
                                  >
                                    {isVisibleConfirmPassword ? (
                                      <i className="bx bx-hide"></i>
                                    ) : (
                                      <i className="bx bx-show"></i>
                                    )}
                                  </button>
                                </InputGroupAddon>
                                <AvFeedback>
                                  {t("Passwords do not match, try again.")}
                                </AvFeedback>
                              </InputGroup>
                            </AvGroup>

                            <Button
                              color="primary"
                              className="mr-1 waves-effect waves-light"
                              style={{
                                minWidth: "100px",
                                cursor: enableSubmit ? "pointer" : "no-drop",
                              }}
                              onClick={handleGeneratePassword}
                            >
                              {t("Generate random password")}
                            </Button>
                          </>
                        )}
                        <FormGroup className="form-box">
                          <SwitchEvent
                            id="automationUser"
                            title="Access only via API (automation user)"
                            tooltip="When defining the user as an automation user, login can only be performed via API to grant authorization to other system resources."
                            value={isAutomationOnly}
                            onChange={(val) => {
                              setIsAutomationOnly(val);
                              if (val === userValues.isAutomationOnly) {
                                delete newFields.is_automation_only;
                                checkSubmit();
                              } else {
                                setNewFields((previous) => ({
                                  ...previous,
                                  is_automation_only: val,
                                }));
                              }
                            }}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Button
                      type="submit"
                      color="primary"
                      className="mr-1 waves-effect waves-light"
                      style={{
                        minWidth: "100px",
                        cursor: enableSubmit ? "pointer" : "no-drop",
                      }}
                      disabled={!enableSubmit}
                    >
                      {loadingUserEditCreate ? (
                        <Spinner
                          size="sm"
                          animation="border"
                          style={{
                            height: "19px",
                            width: "19px",
                          }}
                        />
                      ) : (
                        t("Confirm")
                      )}
                    </Button>
                    <Link to="/users">
                      {" "}
                      <Button
                        type="button"
                        color="secondary"
                        className="waves-effect btn-dark"
                        onClick={() => dispatch(resetUser())}
                      >
                        {t("Cancel")}
                      </Button>
                    </Link>
                  </AvForm>
                  {idUser && data.permissions["change_password"] && (
                    <AvForm onValidSubmit={handleChangePassword}>
                      <Col sm="6">
                        <Label className="font-size-16 text-dark mt-4">
                          {t("Update password")}
                        </Label>
                        <div className="feature-card mb-2 reset-password-form p-3">
                          <AvGroup>
                            <Label for="password">{t("New password")}</Label>
                            <InputGroup>
                              <AvInput
                                name="password"
                                type={isVisiblePassword ? "text" : "password"}
                                value={newPassword}
                                onChange={(e) => setNewPassword(e.target.value)}
                                placeholder={t("New password")}
                                validate={{
                                  pattern: {
                                    value:
                                      /^(?=.*[A-Z])(?=.*[0-9])(?=.*[~`!@#$%^&*()--+={}[\]|\\:;"'<>,.?/_]).{8,}$/,
                                    errorMessage: t(
                                      "Password must be at least 8 characters long, contain at least one uppercase character, contain at least one number and contain at least one special character"
                                    ),
                                  },
                                }}
                              />
                              <InputGroupAddon addonType="append">
                                <button
                                  type="button"
                                  style={{
                                    backgroundColor: "#2e3548",
                                    color: "#bfc8e2",
                                    outline: "none",
                                    border: "1px solid #32394e",
                                    borderRadius: "0 0.25em 0.25em 0",
                                    width: "3em",
                                    marginLeft: "1px",
                                  }}
                                  onClick={() =>
                                    setIsVisiblePassword(!isVisiblePassword)
                                  }
                                >
                                  {isVisiblePassword ? (
                                    <i className="bx bx-hide"></i>
                                  ) : (
                                    <i className="bx bx-show"></i>
                                  )}
                                </button>
                              </InputGroupAddon>
                              <AvFeedback>
                                {t(
                                  "Password must be at least 8 characters long, contain at least one uppercase character, contain at least one number and contain at least one special character"
                                )}
                              </AvFeedback>
                            </InputGroup>
                          </AvGroup>

                          <AvGroup>
                            <Label for="passwordConfirm">
                              {t("Confirm new password")}
                            </Label>
                            <InputGroup>
                              <AvInput
                                name="passwordConfirm"
                                type={
                                  isVisibleConfirmPassword ? "text" : "password"
                                }
                                value={confirmNewPassword}
                                onChange={(e) =>
                                  setConfirmNewPassword(e.target.value)
                                }
                                placeholder={t("Confirm new password")}
                                validate={{
                                  pattern: {
                                    value:
                                      /^(?=.*[A-Z])(?=.*[0-9])(?=.*[~`!@#$%^&*()--+={}[\]|\\:;"'<>,.?/_]).{8,}$/,
                                    errorMessage: t(
                                      "Password must be at least 8 characters long, contain at least one uppercase character, contain at least one number and contain at least one special character"
                                    ),
                                  },
                                  match: {
                                    value: "password",
                                    errorMessage: t(
                                      "Passwords do not match, try again."
                                    ),
                                  },
                                }}
                              />
                              <InputGroupAddon addonType="append">
                                <button
                                  type="button"
                                  style={{
                                    backgroundColor: "#2e3548",
                                    color: "#bfc8e2",
                                    outline: "none",
                                    border: "1px solid #32394e",
                                    borderRadius: "0 0.25em 0.25em 0",
                                    width: "3em",
                                    marginLeft: "1px",
                                  }}
                                  onClick={() =>
                                    setIsVisibleConfirmPassword(
                                      !isVisibleConfirmPassword
                                    )
                                  }
                                >
                                  {isVisibleConfirmPassword ? (
                                    <i className="bx bx-hide"></i>
                                  ) : (
                                    <i className="bx bx-show"></i>
                                  )}
                                </button>
                              </InputGroupAddon>
                              <AvFeedback>
                                {t("Passwords do not match, try again.")}
                              </AvFeedback>
                            </InputGroup>
                          </AvGroup>

                          <div className="mt-2">
                            <Button
                              color="primary"
                              className="mr-1 waves-effect waves-light"
                              style={{
                                minWidth: "100px",
                                cursor: "pointer",
                              }}
                            >
                              {loadingUserPassword ? (
                                <Spinner
                                  size="sm"
                                  animation="border"
                                  style={{
                                    height: "19px",
                                    width: "19px",
                                  }}
                                />
                              ) : (
                                t("Update password")
                              )}
                            </Button>
                            <Button
                              color="primary"
                              className="mr-1 waves-effect waves-light"
                              style={{
                                minWidth: "100px",
                                cursor: "pointer",
                              }}
                              onClick={handleGeneratePassword}
                            >
                              {t("Generate random password")}
                            </Button>
                          </div>
                        </div>
                      </Col>
                    </AvForm>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(NewUser);
